import Button from '../../../../components/Button';
import { t } from '../../../../lang';
import FileItem from './components/FileItem';
import './ShowFiles.scss';

const ShowFiles = ({ handleClose, approvalFiles }) => {
	return (
		<div className='ShowFiles'>
			<div className='ShowFiles__items'>
				{approvalFiles?.map((file, index) => (
					<FileItem
						key={file.Id}
						file={file}
						bottomSeparator={index !== approvalFiles.length - 1}
					/>
				))}
			</div>

			<div className='ShowFiles__bottom'>
				<Button className='ShowFiles__button' onClick={handleClose}>
					{t('Done')}
				</Button>
			</div>
		</div>
	);
};

export default ShowFiles;
